import { Router } from '@angular/router';
import { AppPage, AppPageComponent } from './app-page.component';
import { TopToolbarIconBotton } from '../navigation/navigation-data';
import { Optional } from '../shared.types';

export const BACK_ACTION = 'back';

interface BackToolbarIconButtonState {
  backUrl?: string;
  navigationState?: object;
}

export class BackToolbarIconButton implements TopToolbarIconBotton {
  readonly name = 'zurück';
  readonly icon = 'arrow_back';
  readonly actionName = BACK_ACTION;
  readonly showOnMobileDevice = true;
  readonly showOnDesktopDevice = true;
  readonly state: Optional<BackToolbarIconButtonState> = null;

  constructor(config?: Partial<BackToolbarIconButton>) {
    if (config) {
      Object.assign(this, config);
    }
  }
}

@AppPage({
  showMobileBottomNavbar: false,
  topLeftToolbarIconButton: new BackToolbarIconButton(),
  hideDesktopNavigationMenu: true,
  hideDesktopAccountMenu: true,
  showMobilePageTitle: true,
})
export class SubpageBaseComponent extends AppPageComponent {
  private prevUrl?: string | null = null;

  constructor(public router: Router) {
    super();
    const currentNavigation = this.router.currentNavigation();
    this.prevUrl = currentNavigation?.previousNavigation?.finalUrl?.toString();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  executeAction(actionName: string, state?: Optional<object>, event?: Optional<object>): void {
    if (actionName === BACK_ACTION) {
      this.handleBackAction(state);
    }
  }

  private handleBackAction(state?: Optional<Record<string, Optional<any>>>): void {
    let navUrl = state && state['backUrl'] ? state['backUrl'] : null;
    if (!navUrl) {
      navUrl =
        // prevUrl should not lead to a subroute to prevent endless routing loops
        this.prevUrl && !this.prevUrl.startsWith(this.router.url + '/')
          ? this.prevUrl
          : this.router.url.substring(0, this.router.url.lastIndexOf('/'));
    }
    this.router.navigateByUrl(navUrl, {
      state: state && state['navigationState'] ? state['navigationState'] : state,
    });
  }
}
